'use strict';

import { API_REFERENCE } from '../utilities/constant_api';
import { getvariableValue, zipCodeValidator } from '../utilities/utility';
import { selectmenuAccessibilityCompliance } from '../utilities/helper';
import { formPostJsonResponse, htmlGet, jsonPost } from '../components/ajax';

$(function() {
  var pecosTooltip = $($('.pecos_tootlTip')[0]).text();
  var cboxOptions = {
    maxWidthLg: '900px',
    maxHeightLg: '800px',
    maxWidthMd: '600px',
    maxHeightMd: '500px',
    maxWidthSm: 'auto',
    maxHeightSm: 'auto'
  };
  let createNewPhysicianAjaxFlag = true;
  let createCheckoutNewPhysicianAjaxFlag = true;
  let createShowDoctorAjaxFlag = true;
  let submitAddSearchDoctorAjaxFlag = true;
  let onRemoveDoctorAjaxFlag = true;
  let saveAddDoctorAjaxFlag = true;
  let isValidZipVal = true;
  let cancelPhysicianSearchAjaxFlag = true;
  let createNewPhysicianSearchAjaxFlag = true;
  let nextStepForm = false;
  let isValidPhoneNumber = false;
  let isValidFaxNumber = true;
  const buttonClassCheckoutSearch =
    '.account-addnewdoc-search-results-phys-not-list';
  const noRecordDoctor = '.noRecordDiv_doctorFlow';
  const doctorRowHead = '.doctor_row-header';
  const initialDoctorDiv = '.initial-doctor-div';
  const bodySection = '.section-body';
  $('[id^=pecos-default]').tooltip({
    placement: function placement() {
      var self = this;
      setTimeout(function() {
        var tooltipInner = parseInt(
          self.$tip.find('.tooltip-inner').css('width'),
          10
        );
        var innerVal = parseInt(self.$tip.css('left'), 10);
        var arrowVal = parseInt(self.$arrow.css('left'), 10);
        if (window.innerWidth > 767) {
          self.$tip.css('left', innerVal + tooltipInner / 2.5 + 'px');
          self.$arrow.css('left', arrowVal - tooltipInner / 2.5 + 'px');
        }
      }, 0);
      return 'bottom';
    },
    title: pecosTooltip
  });
  $('#createState,#searchPhysician_state').selectmenu({
    change: function(event, ui) {
      $(event.currentTarget)
        .next()
        .removeAttr('aria-required');
    }
  });
  $('#searchPhysician_state-button').attr('aria-required', 'true');
  var primaryCarePopup = false;
  var numberOfPages;
  var searchedList;
  var range = 8;
  var multiAddressArray = [];
  var multiAddressObj = {
    address: '',
    phoneNumber: '',
    npi: ''
  };

  function addDoctorPage() {
    $('.account-doctor-default').addClass('hidden');
    $('.add_new_doctor').removeClass('hidden');
    $('.add_new_doctor').addClass('show');
    if (location.pathname.indexOf('checkout') > 0) {
      $('.checkout-search-physician-form__cancel_dis').removeClass('hidden');
      $('.checkout-search-physician-form__cancel_dis').addClass('show');
    }
  }

  function createPageList(searchedList) {
    var start = 0;

    for (var i = 0; i < numberOfPages; i++) {
      var increment = createTable(start, i + 1, searchedList);
      start = increment + 1;
    }
  }

  function createTable(start, pageNumber, searchedList) {
    var returnVal;

    for (var j = start; j < range + start && j < searchedList.length; j++) {
      for (var k = 0; k < searchedList[j].providerList.length; k++) {
        searchedList[j].providerList[k].phoneNumber = searchedList[
          j
        ].providerList[k].phoneNumber.replace(
          /(\d{3})(\d{3})(\d{4})/,
          '$1.$2.$3'
        );
      }

      if (location.pathname.indexOf('checkout') > -1) {
        var row = '<div class="account-addnewdoc-search-results-table-body mr-sm-0 hidden" data-page-num='
          .concat(
            pageNumber,
            '>\n      <div class="d-flex align-items-center" role="row">\n\n        <div class="checkout-addnewdoc-search__select align-self-center search-doc_radio selection-group" role="cell">\n          <input type="radio" aria-label="Select' +
              j +
              '" name="doctorList',
            '"\n            class="account-addnewdoc-search-results-table-body__select"\n           data-id="'
          )
          .concat(
            j,
            '" checked="false" data-checked="false"  />\n        </div>\n\n        <div\n          class="checkout-addnewdoc-search__lastname" id="">\n          '
          )
          .concat(
            searchedList[j].lastName,
            '</div>\n        <div\n     role="cell"     class="checkout-addnewdoc-search__firstname">\n          '
          )
          .concat(
            searchedList[j].firstName,
            '</div>\n          <div role="cell" class="checkout-addnewdoc-search__specialty add-user-address">'
          )
          .concat(
            '</div>\n       <div role="cell"  class="checkout-addnewdoc-search__expand"> <button class="btn btn-defualt doctor-list-buttoon-style show-doctor-details" aria-label="doctor list button" role="button"><i class="glyphicon glyphicon-chevron-down"></i></button><button class="btn btn-defualt doctor-list-buttoon-style hidden hide-doctor-details"><i class="glyphicon glyphicon-chevron-up"></i><span class="sr-only">view</span></button>      '
          )
          .concat(
            searchedList[j].phoneExtension
              ? searchedList[j].phoneExtension
              : '',
            '\n        \n        </div>\n    </div>\n\n      <div data-id="'
          )
          .concat(
            j,
            '"\n      class="account-addnewdoc-search-results-table-additional-container checkout-search-result-border hidden">\n      <div class="col-xs-12 account-addnewdoc-search-results-table-additional ">\n      <div class="col-xs-12 account-idc-review checkout-physician-search-expand">\n '
          )
          .concat(
            '<div class="row account-idc-review-details pt-4">\n     ' +
              '<div class="col-xs-12 row col-sm-6 account-idc-review-details-location hidden">\n        ' +
              ' <div class="col-xs-4 account-idc-review-details-location__heading">Address</div>    ' +
              ' <div class=" col-xs-8 pl-0 pr-0 account-idc-review-details-location__address">'
          )
          .concat(searchedList[j].address, '<br>\n     ')
          .concat(searchedList[j].city, ', ')
          .concat(searchedList[j].state, ' ')
          .concat(
            searchedList[j].zipCode,
            '</div>\n </div>\n <div class="col-xs-12 row col-sm-6 account-idc-review-details-contact pt-4 pt-sm-0 hidden">\n     <div class="col-xs-4 account-idc-review-details-contact__heading">        Phone     </div>  <div class="col-xs-8 pl-0 pr-0">   <div class="account-idc-review-details-contact__phnNbr">\n   Phone: <span class="pl-1"><a>'
          )
          .concat(
            searchedList[j].phoneNumber,
            '</a></span>     </div>\n  </div>\n\n </div>\n '
          )
          .concat(
            searchedList[j].providerList[0].pecosCertifiedFlag
              ? '<div class="col-xs-12 account-idc-review-details-contact__pecos col-sm-offset-4 py-4">\n         <span>PECOS Certified</span>\n         <span class=" pl-2"><a id="pecos-review' +
                  j +
                  '" title="The doctor is registered in the Provider Enrollment,Chain and Ownership System (PECOS) to be able to accept Medicare plans.">\n'.concat(
                    '<span aria-label="Information Icon"\n class="svg-icon_information_small_blue svg-icon_information_small_blue-dims account-idc-review-details-contact__pecos-img" role="img"></span>\n     </a>\n     </span>\n     </div>'
                  )
              : '',
            '\n\n     </div>\n     <div class="row account-idc-review-divider hidden hidden-xs m-0 pt-4 pb-4">\n         <div class="col-xs-12"></div>\n     </div>\n     ' +
              '<div class="account-idc-review-details__review-inform row hidden pt-4 pt-sm-5">\n         <div class="col-xs-12">Additional Information</div>\n </div>\n\n <form action="" class="saveSearchPhysician" id="reviewForm'
          )
          .concat(
            j,
            '" class="row pt-3 account-idc-review-details-add-form account-idc-review-details-add-form-row add-physician-form" data-click="">\n   <input type="hidden" class="providerId" name="providerId" value="'
          )
          .concat(
            searchedList[j].providerId,
            '" />\n  <input type="hidden" class="multiAddressFlag" name="multiAddressFlag" />   <input type="hidden"  class="state" name="state" value="'
          )
          .concat(
            searchedList[j].state,
            '" />\n   <input type="hidden"  class="locationId" name="locationId" value="'
          )
          .concat(
            searchedList[j].locationId,
            '" />\n  <input type="hidden"  class="speciality" name="speciality" value="'
          )
          .concat(
            searchedList[j].specialty,
            '" />\n' + '<input type="hidden"  class="city" name="city" value="'
          )
          .concat(
            searchedList[j].city,
            '" />\n ' +
              '<input type="hidden"  class="zipCode" name="zipCode" value="'
          )
          .concat(
            searchedList[j].zipCode,
            '" />\n' +
              '  <input type="hidden" name="pcpFlag" class="pcfFlag" value="false"/>\n <div class="col-xs-12 col-sm-3 account-idc-review-details-add-form-row__office-cont hidden pr-sm-0 pt-2 pt-sm-3 pt-lg-0">\n         <label for="reviewOfficeCont class="hidden"'
          )
          .concat(
            j,
            '">Office Contact</label>\n     <input type=" text" maxlength="35" id="reviewOfficeCont'
          )
          .concat(
            j,
            '" class="d-block" name="addtlOfficeContact" value="" aria-label="Office Contact" />\n\n     <div class=" hidden account-idc-review-details-add-form-row__off-contact--error error-msg">\n         Office Contact field exceeds the character limit\n     </div>\n\n     </div>\n\n     ' +
              '<div\n         class="col-xs-7 col-sm-3 account-idc-review-details-add-form-row__phn-nbr hidden pt-lg-0 pr-sm-0 pt-2 pt-sm-3">\n         <label for="reviewPhoneNbr'
          )
          .concat(
            j,
            '">Phone Number</label>\n         <input type=" text" placeholder="xxx.xxx.xxxx" name="addtlPhoneNum" class="d-block" maxlength="12" id="reviewPhoneNbr'
          )
          .concat(
            j,
            '" value=""\n             data-key="" aria-label="Phone Number" />\n         <div class=" hidden account-idc-review-details-add-form-row__phn-nbr--error error-msg">\n            Phone Number is invalid\n         </div>\n     </div>\n     ' +
              '<div\n         class="col-xs-5 col-sm-2 account-idc-review-details-add-form-row__ext hidden pt-lg-0 pr-sm-0 pt-2 pt-sm-3">\n             <label for="reviewExt'
          )
          .concat(
            j,
            '">EXT</label>\n             <input aria-label="Extension" type=" text" name="addtlExtensionNum" class="d-block" maxlength="10" id="reviewExt'
          )
          .concat(
            j,
            '"\n                 value="" />\n\n             <div class=" hidden account-idc-review-details-add-form-row__ext--error error-msg">\n               Phone Number extension is invalid\n             </div>\n\n     </div>\n     <div\n         class="col-xs-12 col-sm-3 hidden account-idc-review-details-add-form-row__fax pt-2 pt-sm-3 pt-lg-0 pr-sm-0">\n             ' +
              '<label for =reviewFax'
          )
          .concat(
            j,
            '">Fax Number</label>\n             <input type=" text" class="d-block" name="addtlFaxNum" placeholder="xxx.xxx.xxxx" id="reviewFax'
          )
          .concat(
            j,
            '" maxlength="12" value=""\n                 data-key="" aria-label="Fax Number" />\n             <div class="hidden account-idc-review-details-add-form-row__fax-nbr--error error-msg">\n                 Fax Number is invalid\n         </div>\n     </div>\n               ' +
              '  <div class="col-xs-12 pt-5 hidden account-idc-review-details-add-form-btn pb-5 text-sm-right pr-sm-0">\n                    ' +
              ' <button\n                         class="btn custom-button account-idc-review-details-add-form-btn__detail btn-primary small pt-0 pb-0">Add doctor</button>\n                 ' +
              '</div>\n\n </form>\n </div>\n\n                                                 </div></div>\n      </div>'
          );
      } else {
        var row = '<div role="row" class="row account-addnewdoc-search-results-table-body mr-sm-0 hidden" data-page-num='
          .concat(
            pageNumber,
            '>\n      <div class="d-flex align-items-center py-2">\n\n        <div role="gridcell" class="col-xs-1 text-sm-center align-self-center search-doc_radio selection-group">\n          <input type="radio" aria-label="' +
              searchedList[j].firstName +
              +searchedList[j].lastName +
              '" name="doctorList'
          )
          .concat(
            j,
            '"\n            class="account-addnewdoc-search-results-table-body__select"\n           data-id="'
          )
          .concat(
            j,
            '" checked="false" data-checked="false" />\n        </div>\n\n        <div\n  role="gridcell"        class="col-xs-3 col-sm-2 col-lg-1 pl-3 pr-0 pr-sm-2 account-addnewdoc-search-results-table-header__name" id="">\n          '
          )
          .concat(
            searchedList[j].lastName,
            '</div>\n        <div\n          class=" col-xs-3 col-sm-2 col-lg-1 pl-3 pl-sm-0 account-addnewdoc-search-results-table-header__name" role="gridcell">\n          '
          )
          .concat(searchedList[j].firstName, '</div>\n ')
          .concat(
            '<div\n          class="row col-xs-5 col-sm-7 col-lg-8 px-0 add-user-address" role="gridcell">\n          '
          )
          .concat('\n    </div> </div>\n\n      <div data-id="')
          .concat(
            j,
            '"\n      class="account-addnewdoc-search-results-table-additional-container hidden">\n      <div class="col-xs-12 account-addnewdoc-search-results-table-additional ">\n      <div class="col-xs-12 account-idc-review">\n     <div class=" row account-idc-review-header pt-4">\n <div class=" row account-idc-review-header__physicianOverview ml-4 pb-4">\n Doctor Overview</div>\n<div class="col-xs-12 col-sm-4 account-idc-review-header__name">'
          )
          .concat(searchedList[j].lastName, ', ')
          .concat(searchedList[j].firstName, '</div>\n    ')
          .concat(
            searchedList[j].providerList[0].pecosCertifiedFlag
              ? '<div class="account-idc-review-details col-sm-4"><div class="col-xs-12 account-idc-review-details-contact__pecos">\n         <span>PECOS Certified</span>\n         <span class=" pl-2"><a id="pecos-review' +
                  j +
                  '" title="The doctor is registered in the Provider Enrollment,Chain and Ownership System (PECOS) to be able to accept Medicare plans.">\n         <img src="'.concat(
                    ACC.config.themeResourcePath,
                    '/images/external/icon_information_small.svg" tabindex="0"  alt="Information Icon"\n             class="account-idc-review-details-contact__pecos-img" />\n     </a>\n     </span>\n     </div> </div>'
                  )
              : '',
            '    <div class="col-xs-12 col-sm-12 col-lg-4 account-idc-review-header-primary pt-4 d-flex pt-lg-0">\n     <div id="searchResultsPrimaryDocToggle">Primary care doctor</div>\n\n     <div class="pl-3 d-flex createDoctorPrimaryToggle">\n         <div class="d-flex account-idc-review-header-primary__toggler" role="button" aria-pressed="false" tabindex="0" aria-label="No" aria-describedby="searchResultsPrimaryDocToggle">\n\n             ' +
              '<div class="account-idc-review-header-primary__toggler-yes text-center account-idc-review-header-primary__toggler-yes--inactivate">\n                 <span class="toggler-text">Yes</span></div>\n             ' +
              '<div class="account-idc-review-header-primary__toggler-no text-center account-idc-review-header-primary__toggler-no--activate">\n                 <span class="toggler-text">No</span></div>\n         </div>\n         <div class="toggle__overlay"></div>\n     </div>\n </div>\n </div>\n     <div class="row account-idc-review-details  pt-4">\n     '
          )
          .concat(
            '<div class="col-xs-12 col-sm-4 account-idc-review-details-contact hidden pt-4 pt-sm-0">\n          <div class="account-idc-review-details-contact__phnNbr">\n   Phone: <span class="pl-1"><a>'
          )
          .concat(
            searchedList[j].phoneNumber,
            '</a></span>\n     </div>\n     \n </div>\n '
          )
          .concat(
            '\n\n     </div>\n     <div class="row account-idc-review-divider hidden-xs m-0 pt-4 pb-4">\n         <div class="col-xs-12"></div>\n     </div>\n     ' +
              '<div class="account-idc-review-details__review-inform row pt-4 pt-sm-5">\n         <div class="col-xs-12">Additional Information</div>\n </div>\n\n <form action="" id="reviewForm'
          )
          .concat(
            j,
            '" class="row pt-3 account-idc-review-details-add-form account-idc-review-details-add-form-row add-physician-form" data-click="">\n   <input type="hidden" name="providerId" class="providerId" value="'
          )
          .concat(
            searchedList[j].providerId,
            '" />\n   <input type="hidden" class="state" name="state" value="'
          )
          .concat(
            searchedList[j].state,
            '" />\n   <input type="hidden" class="locationId" name="locationId" value="'
          )
          .concat(
            searchedList[j].locationId,
            '" />\n <input type="hidden" class="multiAddressFlag" name="multiAddressFlag" /> <input type="hidden" class="speciality" name="speciality" value="'
          )
          .concat(
            searchedList[j].specialty,
            '" />\n' + '<input type="hidden" class="city" name="city" value="'
          )
          .concat(
            searchedList[j].city,
            '" />\n ' +
              '<input type="hidden"  class="zipCode" name="zipCode" value="'
          )
          .concat(
            searchedList[j].zipCode,
            '" />\n' +
              '  <input type="hidden" name="pcpFlag" class="pcfFlag" value="false"/>\n <div class="col-xs-12 col-sm-3 account-idc-review-details-add-form-row__office-cont pr-sm-0 pt-2 pt-sm-3 pt-lg-0">\n         <label for="reviewOfficeCont'
          )
          .concat(
            j,
            '">Office Contact</label>\n     <input type=" text" maxlength="35" id="reviewOfficeCont'
          )
          .concat(
            j,
            '" class="d-block" name="addtlOfficeContact" value="" aria-label="Office Contact" />\n\n     <div class=" hidden account-idc-review-details-add-form-row__off-contact--error error-msg">\n         Office Contact field exceeds the character limit\n     </div>\n\n     </div>\n\n     ' +
              '<div\n         class="col-xs-7 col-sm-3 account-idc-review-details-add-form-row__phn-nbr pt-lg-0 pr-sm-0 pt-2 pt-sm-3">\n         <label for="reviewPhoneNbr'
          )
          .concat(
            j,
            '">Phone Number</label>\n         <input type=" text" placeholder="xxx.xxx.xxxx" name="addtlPhoneNum" class="d-block editDoctorInput formatDoctorPhone editDoctorPhoneNumber" pattern="(?!0{3}.0{3}.0{4})[0-9]{3}.[0-9]{3}.[0-9]{4}" data-validateeditphonenumflag="true" maxlength="12" id="reviewPhoneNbr'
          )
          .concat(
            j,
            '" value=""\n             data-key="" aria-label="Phone Number" />\n         <div class=" hidden account-idc-review-details-add-form-row__phn-nbr--error error-msg-text">\n            Phone Number is invalid\n         </div>\n  <div class=" hidden account-idc-review-details-add-form-row__phn-nbr--error1 error-msg-text">\n            You\'ve entered an incorrect value \n         </div>\n   </div>\n     ' +
              '<div\n         class="col-xs-5 col-sm-2 account-idc-review-details-add-form-row__ext pt-lg-0 pr-sm-0 pt-2 pt-sm-3">\n             <label for="reviewExt'
          )
          .concat(
            j,
            '">EXT</label>\n             <input aria-label="Extension" type=" text" name="addtlExtensionNum" class="d-block" maxlength="10" id="reviewExt'
          )
          .concat(
            j,
            '"\n                 value="" />\n\n             <div class=" hidden account-idc-review-details-add-form-row__ext--error error-msg">\n               Phone Number extension is invalid\n             </div>\n\n     </div>\n     <div\n         class="col-xs-12 col-sm-3 account-idc-review-details-add-form-row__fax pt-2 pt-sm-3 pt-lg-0 pr-sm-0">\n             ' +
              '<label for =reviewFax'
          )
          .concat(
            j,
            '">Fax Number</label>\n             <input type=" text" class="d-block editDoctorInput formatDoctorPhone editDoctorFaxNumber" name="addtlFaxNum" placeholder="xxx.xxx.xxxx" pattern="(?!0{3}.0{3}.0{4})[0-9]{3}.[0-9]{3}.[0-9]{4}" data-validateeditfaxnumflag="true" id="reviewFax'
          )
          .concat(
            j,
            '" maxlength="12" value=""\n                 data-key="" aria-label="Fax Number" />\n             <div class="hidden account-idc-review-details-add-form-row__fax-nbr--error error-msg-text">\n                 Fax Number is invalid\n         </div>\n  <div class="hidden account-idc-review-details-add-form-row__fax-nbr--error1 error-msg-text">\n                 You\'ve entered an incorrect value \n         </div>\n   </div>\n               ' +
              '  <div class="col-xs-12 pt-5 account-idc-review-details-add-form-btn pb-5 text-sm-right pr-sm-0">\n                    ' +
              ' <button\n                         class="btn custom-button account-idc-review-details-add-form-btn__detail btn-primary small pt-0 pb-0">Add doctor</button>\n                 ' +
              '</div>\n\n </form>\n </div>\n\n                                                 </div></div>\n      </div>'
          );
      }
      const sanitizeHtml = ACC.sanitizer.sanitizeHtmlDeeply(row);
      $(sanitizeHtml)
        .find('.account-addnewdoc-search-results-table-additional-container')
        .append('.account-addnewdoc-search-results-table-additional');

      $('.account-addnew-doctor-list').append(sanitizeHtml);

      if (location.pathname.indexOf('checkout') > -1) {
        for (var m = 0; m < searchedList[j].providerList.length; m++) {
          var addressSection =
            '<div class="d-flex address-list">' +
            '<input type="hidden" class="address-list-data" ' +
            'data-address="' +
            searchedList[j].providerList[m].address +
            '" data-city="' +
            searchedList[j].providerList[m].city +
            '" data-state="' +
            searchedList[j].providerList[m].state +
            '" data-providerId="' +
            searchedList[j].providerList[m].providerId +
            '" data-locationId="' +
            searchedList[j].providerList[m].locationId +
            '" data-phoneNumber="' +
            searchedList[j].providerList[m].phoneNumber +
            '" data-zipCode="' +
            searchedList[j].providerList[m].zipCode +
            '" data-speciality="' +
            searchedList[j].providerList[m].specialty +
            '" />' +
            '<div class="checkout-multi-speciality" role="cell">' +
            searchedList[j].providerList[m].specialty +
            '</div>' +
            '<div class="checkout-multi-city hidden-xs city-name-overlap" role="cell">' +
            searchedList[j].providerList[m].city +
            '</div>' +
            '<div class="checkout-multi-state hidden-xs" role="cell">' +
            searchedList[j].providerList[m].state +
            '</div>' +
            '</div>';

          const sanitizeHtmlAddress = ACC.sanitizer.sanitizeHtmlDeeply(
            addressSection
          );
          $('.add-user-address')
            .eq(j)
            .append(sanitizeHtmlAddress);
        }

        if (!searchedList[j].multiAddressFlag) {
          $('.saveSearchPhysician')
            .eq(j)
            .find('.providerId')
            .val(searchedList[j].providerList[0].providerId);
          $('.saveSearchPhysician')
            .eq(j)
            .find('.multiAddressFlag')
            .val(searchedList[j].multiAddressFlag);
          $('.saveSearchPhysician')
            .eq(j)
            .find('.state')
            .val(searchedList[j].providerList[0].state);
          $('.saveSearchPhysician')
            .eq(j)
            .find('.locationId')
            .val(searchedList[j].providerList[0].locationId);
          $('.saveSearchPhysician')
            .eq(j)
            .find('.speciality')
            .val(searchedList[j].providerList[0].specialty);
          $('.saveSearchPhysician')
            .eq(j)
            .find('.city')
            .val(searchedList[j].providerList[0].city);
          $('.saveSearchPhysician')
            .eq(j)
            .find('.zipCode')
            .val(searchedList[j].providerList[0].zipCode);
        }
      } else {
        for (var m = 0; m < searchedList[j].providerList.length; m++) {
          var addressSection =
            '<div class="col-xs-12 d-flex addres-list">' +
            '<input type="hidden" class="address-list-data" ' +
            'data-address="' +
            searchedList[j].providerList[m].address +
            '" data-city="' +
            searchedList[j].providerList[m].city +
            '" data-state="' +
            searchedList[j].providerList[m].state +
            '" data-phoneNumber="' +
            searchedList[j].providerList[m].phoneNumber +
            '" data-providerId="' +
            searchedList[j].providerList[m].providerId +
            '" data-locationId="' +
            searchedList[j].providerList[m].locationId +
            '" data-zipCode="' +
            searchedList[j].providerList[m].zipCode +
            '" data-speciality="' +
            searchedList[j].providerList[m].specialty +
            '" />' +
            '<div role="gridcell" class="col-xs-3 col-sm-4 col-lg-3">' +
            searchedList[j].providerList[m].specialty +
            '</div>' +
            '<div role="gridcell" class="col-xs-1 visible-lg col-sm-5 col-lg-3 addnewdoc-search-results-table-header__address pr-0">' +
            searchedList[j].providerList[m].address +
            '</div>' +
            '<div role="gridcell" class="col-xs-1 hidden-xs col-sm-4 col-lg-2 addnewdoc-search-results-table-header__city px-0 city-name-overlap">' +
            searchedList[j].providerList[m].city +
            '</div>' +
            '<div role="gridcell" class="col-xs-1 hidden-xs col-sm-3 col-lg-2 px-0">' +
            searchedList[j].providerList[m].state +
            '</div>' +
            '<div role="gridcell" class="col-xs-1 visible-lg col-sm-2 pr-0 col-lg-1 addnewdoc-search-results-table-header__phone px-0"><a>' +
            searchedList[j].providerList[m].phoneNumber +
            '</a></div></div>';

          const sanitizeHtmlAddress = ACC.sanitizer.sanitizeHtmlDeeply(
            addressSection
          );
          $('.add-user-address')
            .eq(j)
            .append(sanitizeHtmlAddress);
        }

        if (!searchedList[j].multiAddressFlag) {
          $('.add-physician-form')
            .eq(j)
            .find('.providerId')
            .val(searchedList[j].providerList[0].providerId);
          $('.add-physician-form')
            .eq(j)
            .find('.multiAddressFlag')
            .val(searchedList[j].multiAddressFlag);
          $('.add-physician-form')
            .eq(j)
            .find('.state')
            .val(searchedList[j].providerList[0].state);
          $('.add-physician-form')
            .eq(j)
            .find('.locationId')
            .val(searchedList[j].providerList[0].locationId);
          $('.add-physician-form')
            .eq(j)
            .find('.speciality')
            .val(searchedList[j].providerList[0].specialty);
          $('.add-physician-form')
            .eq(j)
            .find('.city')
            .val(searchedList[j].providerList[0].city);
          $('.add-physician-form')
            .eq(j)
            .find('.zipCode')
            .val(searchedList[j].providerList[0].zipCode);
        }

        $.each(
          $('.addnewdoc-search-results-table-header__phone').find('a'),
          function(j, item) {
            item.text = item.text.replace(/(\d{3})(\d{3})(\d{4})/, '$1.$2.$3');
          }
        );
      }

      returnVal = j;
    }

    return returnVal;
  }

  function preventAlphabetsAndSpecialCharacters() {
    // eslint-disable-next-line no-useless-escape
    var regExp = /[^0-9\.]/g;
    var value = $(this).val();
    var rightSubstring = value.substring(0, value.length - 1);
    var keyCode = $(this).attr('data-key');

    if (keyCode !== '8' && keyCode !== '9') {
      if (regExp.test(value)) {
        $(this).val(rightSubstring);
      }

      var id = $(this)
        .attr('id')
        .toLowerCase();

      if (id.indexOf('fax') !== -1 || id.indexOf('phone') !== -1) {
        if (value.length === 3 || value.length === 7) {
          $(this).val(value + '.');
        }
      }
    }
  }

  function editWhichButtonClicked() {
    var parent = $(this)
      .parent()
      .parent()
      .parent()
      .parent()
      .parent();
    var editForm = $(parent).find("form[id^='editForm']");

    if ($(this).hasClass('account-idc-edit-controls-buttons__save')) {
      $(editForm).attr('data-click', 'save');
    } else if ($(this).hasClass('account-idc-edit-controls-buttons__cancel')) {
      $(editForm).attr('data-click', 'cancel');
    } else {
      $(editForm).attr('data-click', 'remove');
    }
  }

  function validateOfficeContact(thisObj) {
    var field = thisObj.target
      ? $(this)
      : $(thisObj).find("input[id^='reviewOfficeCont']");
    var errorDiv = $(field).next();
    var name = /^[a-zA-Z0-9\s'-]+$/;
    var returnVal = true;

    if ($(field).val().length > 0) {
      if ($(field).val().length > 35 || !name.test($(field).val())) {
        $(errorDiv).removeClass('hidden');
        $(field).addClass('error--bordering');
        returnVal = false;
      } else {
        if (!$(errorDiv).hasClass('hidden')) {
          $(errorDiv).addClass('hidden');
        }

        $(field).removeClass('error--bordering');
        returnVal = true;
      }
    } else {
      if (!$(errorDiv).hasClass('hidden')) {
        $(errorDiv).addClass('hidden');
      }

      $(field).removeClass('error--bordering');
      returnVal = true;
    }

    return returnVal;
  }

  function validateExt(thisObj) {
    var regExp = /[^0-9]/g;
    var field = thisObj.target
      ? $(this)
      : $(thisObj).find("input[id^='reviewExt']");
    var errorDiv = $(field).next();
    var returnVal = true;

    if ($(field).val().length > 0) {
      if (regExp.test($(field).val())) {
        $(errorDiv).removeClass('hidden');
        $(field).addClass('error--bordering');
        returnVal = false;
      } else {
        if (!$(errorDiv).hasClass('hidden')) {
          $(errorDiv).addClass('hidden');
        }

        $(field).removeClass('error--bordering');
        returnVal = true;
      }
    } else {
      if (!$(errorDiv).hasClass('hidden')) {
        $(errorDiv).addClass('hidden');
      }

      $(field).removeClass('error--bordering');
      returnVal = true;
    }

    return returnVal;
  }

  function validateReviewPhnAndFaxNbr() {
    var id = $(this).attr('id');
    var val = $(this).val();
    var regExp = /(\d{3})\.?(\d{3})\.?(\d{4})/;
    var parent = $(this).parent();
    var phoneNbrField = $(parent).find("input[id^='reviewPhoneNbr']");
    var phoneNbrErrorDiv = $(parent).find(
      '.account-idc-review-details-add-form-row__phn-nbr--error'
    );
    var faxNbrField = $(parent).find("input[id^='reviewFax']");
    var faxNbrErrorDiv = $(parent).find(
      '.account-idc-review-details-add-form-row__fax-nbr--error'
    );

    if (val.length > 0) {
      if (regExp.test(val)) {
        if (id.indexOf('reviewPhoneNbr') !== -1) {
          if (!$(phoneNbrErrorDiv).hasClass('hidden')) {
            $(phoneNbrErrorDiv).addClass('hidden');
          }

          $(phoneNbrField).removeClass('error--bordering');
        } else if (id.indexOf('reviewFax') !== -1) {
          if (!$(faxNbrErrorDiv).hasClass('hidden')) {
            $(faxNbrErrorDiv).addClass('hidden');
          }

          $(faxNbrField).removeClass('error--bordering');
        }
      } else if (!regExp.test(val)) {
        if (id.indexOf('reviewPhoneNbr') !== -1) {
          $(phoneNbrErrorDiv).removeClass('hidden');
          $(phoneNbrField).addClass('error--bordering');
        } else if (id.indexOf('reviewFax') !== -1) {
          $(faxNbrErrorDiv).removeClass('hidden');
          $(faxNbrField).addClass('error--bordering');
        }
      }
    } else if (val.length === 0) {
      if (id.indexOf('reviewFax') !== -1) {
        if (!$(phoneNbrErrorDiv).hasClass('hidden')) {
          $(phoneNbrErrorDiv).addClass('hidden');
        }

        $(phoneNbrField).removeClass('error--bordering');
      } else if (id === 'reviewFax') {
        if (!$(faxNbrErrorDiv).hasClass('hidden')) {
          $(faxNbrErrorDiv).addClass('hidden');
        }

        $(faxNbrField).removeClass('error--bordering');
      }
    }
  }

  function validateEditPhoneNbr(thisObj) {
    var regExp = /(\d{3})\.?(\d{3})\.?(\d{4})/;
    var phoneNbrField = $(thisObj).find("input[id^='reviewPhoneNbr']");
    var faxNbrField = $(thisObj).find("input[id^='reviewFax']");
    var returnVal = true;

    if ($(thisObj).hasClass('account-idc-review-details-edit-form')) {
      phoneNbrField = $(thisObj).find("input[id^='editPhoneNbr']");
      faxNbrField = $(thisObj).find("input[id^='editFaxNbr']");
    }

    var phoneNbrLength = $(phoneNbrField).val().length;
    var phoneValTest =
      phoneNbrLength > 0 ? regExp.test($(phoneNbrField).val()) : true;
    var faxValTest =
      $(faxNbrField).val().length > 0
        ? regExp.test($(faxNbrField).val())
        : true;
    var phoneErrorDiv = $(thisObj).find(
      '.account-idc-review-details-add-form-row__phn-nbr--error'
    );
    var faxErrorDiv = $(thisObj).find(
      '.account-idc-review-details-add-form-row__fax-nbr--error'
    );

    if (phoneValTest) {
      if (!$(phoneErrorDiv).hasClass('hidden')) {
        $(phoneErrorDiv).addClass('hidden');
        $(phoneNbrField).removeClass('error--bordering');
        returnVal = false;
      }
    } else {
      $(phoneErrorDiv).removeClass('hidden');
      $(phoneNbrField).addClass('error--bordering');
      returnVal = false;
    }

    if (faxValTest) {
      if (!$(faxErrorDiv).hasClass('hidden')) {
        $(faxErrorDiv).addClass('hidden');
        $(faxNbrField).removeClass('error--bordering');
        returnVal = false;
      }
    } else {
      $(faxErrorDiv).removeClass('hidden');
      $(faxNbrField).addClass('error--bordering');
      returnVal = false;
    }

    if (phoneValTest && faxValTest) {
      returnVal = true;
    }

    return returnVal;
  }

  function submitEditForm() {
    var returnVal = true;
    var formId = $(this).attr('id');
    var parent = $(this).parent();
    var editForm = $(parent).find("form[id^='editForm']");

    if (formId.indexOf('editForm') !== -1) {
      if ($(editForm).attr('data-click') === 'save') {
        if (!validateEditPhoneNbr($(this))) {
          returnVal = false;
        }
      } else if ($(editForm).attr('data-click') === 'remove') {
        $('#removeDoctorModal').modal('show');
        returnVal = false;
      }
    } else if (formId.indexOf('reviewForm') !== -1) {
      if (
        !validateEditPhoneNbr($(this)) ||
        !validateOfficeContact($(this)) ||
        !validateExt($(this))
      ) {
        returnVal = false;
      }
    }

    return returnVal;
  }

  function populateKey(e) {
    $(this).attr('data-key', e.which);
  }
  /* Functions for Create New Physician begins */

  function validateRequiredFields() {
    var createLastName = $('#createLastName').val().trim();
    var stateVal = $('#createState').val();

    if (
      createLastName.length > 1 &&
      stateVal !== '' && 
      isValidPhoneNumber &&
      isValidFaxNumber &&
      ((isValidZipVal &&
        $('#createZipCode')
          .val()
          .trim() !== '') ||
        $('#createZipCode')
          .val()
          .trim() === '')
    ) {
      // check whether phone number and state are populated if so enable button else do not
      $('.account-create-newphysician-form__add').attr('disabled', false);
    } else {
      $('.account-create-newphysician-form__add').attr('disabled', true);
    }
  }

  $('.editFormatInsurance a').text(function(i, text) {
    text = text.replace(/(\d{3})(\d{3})(\d{4})/, '$1.$2.$3');
    return text;
  });

  function validateOnAddDoctor() {
    var createLastName = $('#createLastName').val().trim();
    var createPhoneNbr = $('#createPhoneNbr').val();
    var stateVal = $('#createState').val();
    var createFaxNbr = $('#createFaxNbr').val();
    var regExp = /(\d{3})\.?(\d{3})\.?(\d{4})/;
    var returnVal = true;

    if (
      createLastName.length > 1 &&
      regExp.test(createPhoneNbr) &&
      stateVal !== ''
    ) {
      // enable submission
      $('.account-create-newphysician-form-lastName-error').addClass('hidden');
      $('#createLastName').removeClass('error--bordering');
      $('.account-create-newphysician-form-phnNbr-error').addClass('hidden');
      $('#createPhoneNbr').removeClass('error--bordering');
      $('.account-create-newphysician-form-state-error').addClass('hidden');
      $('#createState').removeClass('error--bordering');
      $('.account-create-newphysician-form-fax-error').addClass('hidden');
      $('#createFaxNbr').removeClass('error--bordering');
      returnVal = true;
    }

    if (createLastName.length < 2) {
      $('.account-create-newphysician-form-lastName-error').removeClass(
        'hidden'
      );
      $('#createLastName').addClass('error--bordering');
      returnVal = false; // prevent submission of form
    }

    if (!regExp.test(createPhoneNbr)) {
      $('.account-create-newphysician-form-phnNbr-error').removeClass('hidden');
      $('#createPhoneNbr').addClass('error--bordering');
      returnVal = false; // prevent submission of form
    }

    if (stateVal === '') {
      $('.account-create-newphysician-form-state-error').removeClass('hidden');
      $('#createState').addClass('error--bordering');
      returnVal = false; // prevent submission of form
    }

    if (createFaxNbr.length > 0 && !regExp.test(createFaxNbr)) {
      $('.account-create-newphysician-form-fax-error').removeClass('hidden');
      $('#createFaxNbr').addClass('error--bordering');
      returnVal = false;
    }

    return returnVal;
  }

  function showNewDoctor() {
    if (location.pathname.indexOf('checkout') > 0) {
      var url = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutPhysician.viewPhysicians}`;
    } else {
      var url = `${ACC.config.encodedContextPath}${API_REFERENCE.accountDoctor.viewDoctor}`;
    }
    if (!createShowDoctorAjaxFlag) return false;
    createShowDoctorAjaxFlag = false;
    htmlGet(url)
      .then(response => {
        createCheckoutNewPhysicianAjaxFlag = true;
        onRemoveDoctorAjaxFlag = true;
        createNewPhysicianAjaxFlag = true;
        saveAddDoctorAjaxFlag = true;
        createShowDoctorAjaxFlag = true;
        const data = ACC.sanitizer.sanitizeHtmlDeeply(response);
        $('.noRecordDiv_doctorFlow').hide();
        $('.doctor_row-header').html(
          $(data)
            .find('.doctor_row-header')
            .html()
        );
        $('.initial-doctor-div').html(
          $(data)
            .find('.initial-doctor-div')
            .html()
        );
        $('.initial-doctor-div')
          .find('.section-body')
          .css('display', 'block');
        $('#createState,#searchPhysician_state').selectmenu({
          change: function(event, ui) {
            $(event.currentTarget)
              .next()
              .removeAttr('aria-required');
          }
        });
        $('.formatDoctorPhone').val(function(i, text) {
          text = text.replace(/(\d{3})(\d{3})(\d{4})/, '$1.$2.$3');
          return text;
        });
        $('.editFormatInsurance a').text(function(i, text) {
          text = text.replace(/(\d{3})(\d{3})(\d{4})/, '$1.$2.$3');
          return text;
        });
      })
      .catch(error => {
        saveAddDoctorAjaxFlag = true;
        createNewPhysicianAjaxFlag = true;
        onRemoveDoctorAjaxFlag = true;
        createCheckoutNewPhysicianAjaxFlag = true;
        createShowDoctorAjaxFlag = true;
        $('.noRecordDiv_doctorFlow').show();
      });
  }

  function addDoctorSubmit(e) {
    e.preventDefault();
    var returnVal = true;

    if ($('.account-create-newphysician-form').attr('data-click') === 'add') {
      if (!validateOnAddDoctor()) {
        returnVal = false;
      } else {
        const urlValue = location.pathname;
        if (
          urlValue.indexOf('checkout') > -1 &&
          urlValue.indexOf('viewPhysicians') === -1
        ) {
          var formURL = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutPhysician.createPhysician}`;
          var form = $(document).find('#createNewProviderForm');
          const physicianFormErrorData = $('#physicianForm').serialize();
          var data = `${form.serialize()}&${physicianFormErrorData}`;
        } else {
          var formURL = `${ACC.config.encodedContextPath}${API_REFERENCE.accountAddProvider.addNewProvider}`;
          var form = $(document).find('#createNewProviderForm');
          var data = form.serialize();
        }
        $('.global-error-message').addClass('hidden');
        $('.generic-error-container').addClass('hidden');
        if (!createCheckoutNewPhysicianAjaxFlag) return false;
        createCheckoutNewPhysicianAjaxFlag = false;
        formPostJsonResponse(formURL, data)
          .then(response => {
			if(response.cartError != undefined && response.cartError != null && String(response.cartError).toLocaleLowerCase() == 'true'){
                window.location="/";
                return ;
            }
            if (response.errorcode == 'SUCCESS') {
              $('.noRecordDiv_doctorFlow').hide();
              showNewDoctor();
            } else {
              createCheckoutNewPhysicianAjaxFlag = true;
              $('.generic-error-container .generic-error-text').text(
                response.errormessage
              );
              $('.generic-error-container').removeClass('hidden');
              window.scrollTo(0, 0);
            }
          })
          .catch(error => {
            createCheckoutNewPhysicianAjaxFlag = true;
            $('.noRecordDiv_doctorFlow').show();
          });
      }
    }

    return returnVal;
  }

  function validateCreateState() {
    validateRequiredFields();
  }

  function validateCreateLastName() {
    const createNameChk = /^[a-zA-Z0-9\s'-]+$/;
    const createLastName = $('#createLastName').val().trim();
    if (
      (createLastName.length < 2 && createNameChk.test(createLastName)) ||
      createLastName.length === 0
    ) {
      $('.account-create-newphysician-form-lastName-error').removeClass(
        'hidden'
      );
      $('.account-create-newphysician-form-lastName-format-error').addClass(
        'hidden'
      );
      $('#createLastName').addClass('error--bordering');
      $('#createLastName').attr('aria-required', 'true');
    } else if (!createNameChk.test(createLastName)) {
      $('.account-create-newphysician-form-lastName-format-error').removeClass(
        'hidden'
      );
      $('.account-create-newphysician-form-lastName-error').addClass('hidden');
      $('#createLastName').addClass('error--bordering');
      $('#createLastName').attr('aria-required', 'true');
    } else {
      $('.account-create-newphysician-form-lastName-error').addClass('hidden');
      $('.account-create-newphysician-form-lastName-format-error').addClass(
        'hidden'
      );
      $('#createLastName').removeClass('error--bordering');
      $('#createLastName').attr('aria-required', 'false');
    }
    validateRequiredFields();
  }

  function validateCreateFirstName() {
    const createNameChk = /^[a-zA-Z0-9\s'-]+$/;
    const createFirstName = $('#createFirstName').val();
    if (!createNameChk.test(createFirstName)) {
      $('.account-create-newphysician-form-firstName-format-error').removeClass(
        'hidden'
      );
      $('#createFirstName').addClass('error-msg-textbox');
    } else {
      $('.account-create-newphysician-form-firstName-format-error').addClass(
        'hidden'
      );
      $('#createFirstName').removeClass('error-msg-textbox');
    }
  }

  function validateCreatFaxNbr() {
    var createFaxNbr = $('#createFaxNbr').val();
    var regExp = /^0{3}\.0{3}\.0{4}$/;

    if (createFaxNbr.trim() === '' || (createFaxNbr.trim().length == 12 && (!regExp.test(createFaxNbr.trim())))) {
      $('.account-create-newphysician-form-faxNbr-error1').addClass('hidden');
      $('.account-create-newphysician-form-faxNbr-error').addClass('hidden');
      $('#createFaxNbr').removeClass('error--bordering');
      isValidFaxNumber = true;
    } else {
      // add error message,add red border to field
      if(createFaxNbr.trim().length == 12 && (regExp.test(createFaxNbr.trim()))){
        $('.account-create-newphysician-form-faxNbr-error1').removeClass('hidden');
        $('.account-create-newphysician-form-faxNbr-error').addClass('hidden');
      }else{
        $('.account-create-newphysician-form-faxNbr-error').removeClass('hidden');
        $('.account-create-newphysician-form-faxNbr-error1').addClass('hidden');
      }
      $('#createFaxNbr').addClass('error--bordering');
      isValidFaxNumber = false;
    }
    validateRequiredFields();
  }

  function populateAddButtonClicked() {
    $('.account-create-newphysician-form').attr('data-click', 'add');
  }

  function populateCancelButtonClicked() {
    $('.account-create-newphysician-form').attr('data-click', 'cancel');
    showNewDoctor();
  }

  function validateCreatePhoneNbr() {
    var createPhoneNbr = $('#createPhoneNbr').val();
    var regExp = /^0{3}\.0{3}\.0{4}$/;
    if (createPhoneNbr.trim().length == 12 && (!regExp.test(createPhoneNbr.trim()))) {
      $('.account-create-newphysician-form-phnNbr-error1, .account-create-newphysician-form-phnNbr-error').addClass('hidden');
      $('#createPhoneNbr').removeClass('error--bordering');
      $('#createPhoneNbr').attr('aria-required', 'false');
      isValidPhoneNumber = true;
    } else {
      // add error message,add red border to field
      if(createPhoneNbr.trim().length == 12 && (regExp.test(createPhoneNbr.trim()))){
        $('.account-create-newphysician-form-phnNbr-error1').removeClass('hidden');
        $('.account-create-newphysician-form-phnNbr-error').addClass('hidden');
      }else{
        $('.account-create-newphysician-form-phnNbr-error').removeClass('hidden');
        $('.account-create-newphysician-form-phnNbr-error1').addClass('hidden');
      }
      $('#createPhoneNbr').addClass('error--bordering');
      $('#createPhoneNbr').attr('aria-required', 'true');
      isValidPhoneNumber = false;
    }

    validateRequiredFields();
  }

  function validateEditFormPhoneNbr(){
    var editPhoneNbr = $(this).val();
    var regExp = /^0{3}\.0{3}\.0{4}$/;
    if (editPhoneNbr.trim() === '' || (editPhoneNbr.trim().length == 12 && (!regExp.test(editPhoneNbr.trim())))) {
      $(this).siblings('.account-idc-review-details-add-form-row__phn-nbr--error1').addClass('hidden');
      $(this).siblings('.account-idc-review-details-add-form-row__phn-nbr--error').addClass('hidden');
      $(this).removeClass('error--bordering');
      $(this).data("validateeditphonenumflag",true);
    }else{
      if(editPhoneNbr.trim().length == 12 && (regExp.test(editPhoneNbr.trim()))){
        $(this).siblings('.account-idc-review-details-add-form-row__phn-nbr--error1').removeClass('hidden');
        $(this).siblings('.account-idc-review-details-add-form-row__phn-nbr--error').addClass('hidden');
      }else{
        $(this).siblings('.account-idc-review-details-add-form-row__phn-nbr--error').removeClass('hidden');
        $(this).siblings('.account-idc-review-details-add-form-row__phn-nbr--error1').addClass('hidden');
      }
      $(this).addClass('error--bordering');
      $(this).data("validateeditphonenumflag",false);
    }
  }

  function validateEditFormFaxNbr(){
    var editFaxNbr = $(this).val();
    var regExp = /^0{3}\.0{3}\.0{4}$/;
    if (editFaxNbr.trim() === '' || (editFaxNbr.trim().length == 12 && (!regExp.test(editFaxNbr.trim())))) {
      $(this).siblings('.account-idc-review-details-add-form-row__fax-nbr--error1').addClass('hidden');
      $(this).siblings('.account-idc-review-details-add-form-row__fax-nbr--error').addClass('hidden');
      $(this).removeClass('error--bordering');
      $(this).data("validateeditfaxnumflag",true);
    }else{
      if(editFaxNbr.trim().length == 12 && (regExp.test(editFaxNbr.trim()))){
        $(this).siblings('.account-idc-review-details-add-form-row__fax-nbr--error1').removeClass('hidden');
        $(this).siblings('.account-idc-review-details-add-form-row__fax-nbr--error').addClass('hidden');
      }else{
        $(this).siblings('.account-idc-review-details-add-form-row__fax-nbr--error').removeClass('hidden');
        $(this).siblings('.account-idc-review-details-add-form-row__fax-nbr--error1').addClass('hidden');
      }
      $(this).addClass('error--bordering');
      $(this).data("validateeditfaxnumflag",false);
    }
  }
  /* Functions for Create New Physician ends */

  /* Functions for Add New Doctor Search begins */

  function validateAddDoctorReqdFields() {
    var lastName = $('#addLastName').val();
    var phnNbr = $('#provServPhone').val();
    var stateVal = $('#searchPhysician_state-button')
      .find('.ui-selectmenu-text')
      .text()
      .trim();

    if ((lastName.length > 1 || phnNbr.length > 0) && stateVal !== '') {
      $('.account-addnewdoc-form__search').attr('disabled', false);
    } else {
      $('.account-addnewdoc-form__search').attr('disabled', true);
    }
  }

  function validateSearchPhoneNbr() {
    var searchPhnNumber = $(this).val();
    var regExp = /(\d{3})\.?(\d{3})\.?(\d{4})/;

    if (searchPhnNumber.length > 0 && !regExp.test(searchPhnNumber)) {
      // add error message,add red border to field
      $('.account-addnewdoc-phn-nbr__error').removeClass('hidden');
      $('#provServPhone').addClass('error--bordering');
    } else {
      $('.account-addnewdoc-phn-nbr__error').addClass('hidden');
      $('#provServPhone').removeClass('error--bordering');
    }

    validateAddDoctorReqdFields();
  }

  function search() {
    var lastName = $('#addLastName').val();
    var firstName = $('#firstName').val();
    var phnNbr = $('#provServPhone').val();
    var stateVal = $('#searchPhysician_state-button')
      .find('.ui-selectmenu-text')
      .text()
      .trim();
    var regExp = /(\d{3})\.?(\d{3})\.?(\d{4})/;
    var returnval = true;
    const namePattern = /^[a-zA-Z0-9-_ ']+$/;

    $('.error-msg-text').addClass('hidden');

    if ((regExp.test(phnNbr) || lastName.length > 1) && stateVal !== '') {
      $('.account-addnewdoc-last-name__error').addClass('hidden');
      $('#addLastName').removeClass('error--bordering');
      $('.account-addnewdoc-phn-nbr__error').addClass('hidden');
      $('#provServPhone').removeClass('error--bordering');
      $('.account-addnewdoc-state__error').addClass('hidden');
      $('#searchPhysician_state-button').removeClass('error-msg-textbox');
      returnval = true;
    }

    if (lastName.length > 0) {
      $('#addLastName').removeClass('error-msg-textbox');
      if (lastName.length < 2) {
        $('.account-addnewdoc-last-name__error').removeClass('hidden');
        $('#addLastName').addClass('error--bordering');
        returnval = false;
      } else {
        const lastStatus = namePattern.test(lastName);
        if (!lastStatus) {
          $('.error-msg-lastInvalidName').removeClass('hidden');
          $('#addLastName').addClass('error-msg-textbox');
          returnval = false;
        }
      }
    }

    if (firstName.length > 0) {
      $('#firstName').removeClass('error-msg-textbox');
      const nameStatus = namePattern.test(firstName);
      if (!nameStatus) {
        $('.error-msg-firstInvalidName').removeClass('hidden');
        $('#firstName').addClass('error-msg-textbox');
        returnval = false;
      }
    }

    if (phnNbr.length > 0) {
      if (!regExp.test(phnNbr)) {
        $('.account-addnewdoc-phn-nbr__error').removeClass('hidden');
        $('#provServPhone').addClass('error--bordering');
        returnval = false;
      }
    }

    if (stateVal === '') {
      $('.account-addnewdoc-state__error').removeClass('hidden');
      $('#searchPhysician_state-button').addClass('error-msg-textbox');
      returnval = false;
    }

    return returnval;
  }

  function submitAddDoctorSearchForm() {
    if (search()) {
      $('.show-overlay').show();
      var $spinner = $('.addnewdoc-overlay .loader');
      $spinner.show();
      $('.pagination__link').remove();
      $('.account-addnew-doctor-list').empty();
      $('.global-error-message').addClass('hidden');
      $('.generic-error-container').addClass('hidden');
      const searchProviderUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.accountDoctor.searchDoctor}`;
      const submitData = $('#searchProviderForm').serialize();
      if (!submitAddSearchDoctorAjaxFlag) return false;
      submitAddSearchDoctorAjaxFlag = false;
      formPostJsonResponse(searchProviderUrl, submitData)
        .then(data => {
          submitAddSearchDoctorAjaxFlag = true;
          $('.show-overlay').hide();
          $spinner.hide();
          if (data.length === 1 && data[0].errorMessage) {
            $('.generic-error-container .generic-error-text').text(
              data[0].errorMessage
            );
            $('.generic-error-container').removeClass('hidden');
            window.scrollTo(0, 0);
          } else {
            $('.noRecordDiv_doctorFlow').hide();
            $('.account-idc-search-results').removeClass('hidden');
            $('.account-idc-search-results').addClass('show');

            if (data.length > 0) {
              searchedList = data;
              var totalRecords = searchedList.length;
              numberOfPages = Math.floor(
                totalRecords % range === 0
                  ? totalRecords / range
                  : totalRecords / range + 1
              );
              createPageList(searchedList);
              formPagination(numberOfPages);
              $('.account-addnewdoc-no-search-results').addClass('hidden');
              $('.account-addnewdoc-search-results-table-body__select').prop(
                'checked',
                false
              );
              $('.provider_search_select').show();
            } else {
              $('.account-addnewdoc-no-search-results').removeClass('hidden');
              $('.provider_search_select').hide();
              if (location.pathname.indexOf('checkout') > 0) {
                $(buttonClassCheckoutSearch).addClass(
                  'button-margin-offset-50'
                );
              }
            }
          }
        })
        .catch(error => {
          submitAddSearchDoctorAjaxFlag = true;
          $('.noRecordDiv_doctorFlow').show();
          $('.add_new_doctor')
            .find('.global-error-message')
            .removeClass('hidden');
        });
    } else {
      $('.account-idc-search-results').addClass('hidden');
      $('.account-idc-search-results').removeClass('show');
    }

    return false;
  }
  /* Functions for Add New Doctor Search ends */

  function selectingRow(selectedThis) {
    var selectedRow = selectedThis.target ? $(this) : selectedThis;
    var parent = $(selectedRow)
      .parent()
      .parent();
    selectedRow = $(parent).find(
      '.account-addnewdoc-search-results-table-body__select'
    );
    var expand = $(selectedRow).attr('data-id');
    var checkattr = $(selectedRow).attr('data-checked');

    if (checkattr === 'false') {
      $(selectedRow).prop('checked', 'checked');
      $(selectedRow).attr('data-checked', true);
      $('.button-doctor-search-checkout').removeAttr('disabled');
      $(parent)
        .find('.account-addnewdoc-search-results-table-header__dropdown')
        .addClass('svg-icon_circle_minus_blue svg-icon_circle_minus_blue-dims');
      $('div[data-id='.concat(expand, ']')).removeClass('hidden');
      if ($('.checkout-detail').length > 0) {
        $('div[data-id='.concat(expand, ']')).addClass('d-flex');
      }
    } else {
      $(selectedRow).prop('checked', '');
      $(selectedRow).attr('data-checked', false);
      $(parent)
        .find('.account-addnewdoc-search-results-table-header__dropdown')
        .addClass('svg-icon_circle_plus_blue svg-icon_circle_plus_blue-dims');
      $('div[data-id='.concat(expand, ']')).addClass('hidden');
      $('.button-doctor-search-checkout').attr('disabled', 'disabled');
      if ($('.checkout-detail').length > 0) {
        $('div[data-id='.concat(expand, ']')).removeClass('d-flex');
      }
    }
    populateToolTipForReview();
  }

  function populateToolTipForReview() {
    $('[id^=pecos-review]').tooltip({
      placement: function placement() {
        var self = this;
        setTimeout(function() {
          var tooltipInner = parseInt(
            self.$tip.find('.tooltip-inner').css('width'),
            10
          );
          var innerVal = parseInt(self.$tip.css('left'), 10);
          var arrowVal = parseInt(self.$arrow.css('left'), 10);
          if (window.innerWidth > 767) {
            self.$tip.css('left', innerVal + tooltipInner / 2.5 + 'px');
            self.$arrow.css('left', arrowVal - tooltipInner / 2.5 + 'px');
          }
        }, 0);
        return 'bottom';
      },
      title: pecosTooltip
    });
  }

  function checkWidth() {
    if (window.innerWidth >= 992) {
      return cboxOptions.maxWidthLg;
    } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
      return cboxOptions.maxWidthMd;
    } else {
      return cboxOptions.maxWidthSm;
    }
  }

  function checkHeight() {
    if (window.innerHeight >= 992) {
      return cboxOptions.maxHeightLg;
    } else if (window.innerHeight >= 768 && window.innerHeight < 992) {
      return cboxOptions.maxHeightMd;
    } else {
      return cboxOptions.maxHeightSm;
    }
  }

  function removeDoctor(e) {
    e.preventDefault();
    $('#customerProviderRelationId').val($(this).attr('id'));
    $('#providerId').val($(this).attr('data-providerId'));
    $('#isUnverifiedProvider').val($(this).attr('data-isUnverifiedProvider'));
    $('.doctor-removal-modal-error').addClass('hidden');
    var editAddress = ACC.colorbox.open('', {
      html: $('#removeDoctorDiv').html(),
      onLoad: $('#cboxOverlay').css('position', 'fixed'),
      width: checkWidth(),
      height: checkHeight(),
      className: 'account-idc-remove-doctor'
    });
  }

  var primaryCareParent;

  function removeDoctorfromDom() {
    removePhysician();
  }

  function togglingPrimaryCareDoctor() {
    primaryCareParent = $('.createDoctorPrimaryToggle');
    var primaryDoc = 0;
    $('.account-doctor-type').text(function(index, text) {
      var textTrim = text.trim();

      if (textTrim === 'Primary Care Doctor') {
        primaryDoc = primaryDoc + 1;
      }
    });

    if (
      $(primaryCareParent)
        .find('.toggle__overlay')
        .hasClass('toggle__overlay--activate') &&
      $(primaryCareParent)
        .find('.account-idc-review-header-primary__toggler-no')
        .hasClass('account-idc-review-header-primary__toggler-no--inactivate')
    ) {
      $('.account-idc-review-header-primary__toggler').attr(
        'aria-pressed',
        'false'
      );
      $('.account-idc-review-header-primary__toggler').attr('aria-label', 'No');
      $(primaryCareParent)
        .find('.toggle__overlay')
        .removeClass('toggle__overlay--activate');
      $(primaryCareParent)
        .find('.account-idc-review-header-primary__toggler-yes')
        .addClass('account-idc-review-header-primary__toggler-yes--inactivate')
        .removeClass(
          'account-idc-review-header-primary__toggler-yes--activate'
        );
      $(primaryCareParent)
        .find('.account-idc-review-header-primary__toggler-no')
        .removeClass(
          'account-idc-review-header-primary__toggler-no--inactivate'
        )
        .addClass('account-idc-review-header-primary__toggler-no--activate');
      $('.pcfFlag').prop('value', false);
    } else {
      if (primaryDoc > 0) {
        ACC.colorbox.open('', {
          html: $('#switchPrimary').html(),
          onLoad: $('#cboxOverlay').css('position', 'fixed')
        });
      } else {
        $(primaryCareParent)
          .find('.toggle__overlay')
          .addClass('toggle__overlay--activate');
        $(primaryCareParent)
          .find('.account-idc-review-header-primary__toggler-yes')
          .removeClass(
            'account-idc-review-header-primary__toggler-yes--inactivate'
          )
          .addClass('account-idc-review-header-primary__toggler-yes--activate');
        $(primaryCareParent)
          .find('.account-idc-review-header-primary__toggler-no')
          .addClass('account-idc-review-header-primary__toggler-no--inactivate')
          .removeClass(
            'account-idc-review-header-primary__toggler-no--activate'
          );
        $('.pcfFlag').prop('value', true);
        $('.account-idc-review-header-primary__toggler').attr(
          'aria-pressed',
          'true'
        );
        $('.account-idc-review-header-primary__toggler').attr(
          'aria-label',
          'Yes'
        );
      }

      primaryCarePopup = true;
    }
  }

  function editToggler() {
    var editTogglerParent = $('.editDoctorToggle');

    if (
      $(editTogglerParent)
        .find('.toggle__overlay')
        .hasClass('toggle__overlay--activate')
    ) {
      $('.primaryCareFlag').prop('value', true);
    } else {
      $('.primaryCareFlag').prop('value', false);
    }
  }

  function addDoctorPopUpSubmitBtn() {
    primaryCareParent = $('.createDoctorPrimaryToggle');
    $(primaryCareParent)
      .find('.account-idc-review-header-primary__toggler-yes')
      .removeClass('account-idc-review-header-primary__toggler-yes--inactivate')
      .addClass('account-idc-review-header-primary__toggler-yes--activate');
    $('.pcfFlag').prop('value', true);
    $(primaryCareParent)
      .find('.account-idc-review-header-primary__toggler-no')
      .removeClass('account-idc-review-header-primary__toggler-no--activate')
      .addClass('account-idc-review-header-primary__toggler-no--inactivate');
    $(primaryCareParent)
      .find('.toggle__overlay')
      .addClass('toggle__overlay--activate');
    $('.account-idc-review-header-primary__toggler').attr(
      'aria-pressed',
      'true'
    );
    $('.account-idc-review-header-primary__toggler').attr('aria-label', 'Yes');
    editToggler();
    ACC.colorbox.close();
    primaryCarePopup = true;
  }

  function viewCreateNewPhysician() {
    if (location.pathname.indexOf('checkout') > 0) {
      $('.account-idc-search-results').addClass('hidden');
      $('.account-addnewdoc').addClass('hidden');
    }
    $('.account-addnewdoc__create').removeClass('hidden');
    selectmenuAccessibilityCompliance();
  }

  function editPhysician() {
    var buttonParent = $(this)
      .parent()
      .parent()
      .parent()
      .parent();
    $(this)
      .closest('.account-doctor-section')
      .find('.account-idc-edit')
      .removeClass('hidden');
    $(this)
      .closest('.account-doctor-first')
      .hide();
    $(buttonParent)
      .find('.account-doctor__divider')
      .hide();
  }

  $('.editFormatInsurance a').text(function(i, text) {
    var newFormat = text.replace(/(\d{3})(\d{3})(\d{4})/, '$1.$2.$3');
    return newFormat;
  });
  $('.formatDoctorPhone').val(function(i, text) {
    var newFormat = text.replace(/(\d{3})(\d{3})(\d{4})/, '$1.$2.$3');
    return newFormat;
  });

  function expandRow() {
    selectingRow($(this));
  }

  function removePhysician() {
    var customerRltId = $('#customerProviderRelationId').val();
    var providerId = $('#providerId').val();
    var isUnverifiedProvider = $('#isUnverifiedProvider').val();
    var submitLeadUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.accountDoctor.removeDoctor}?customerRltId=${customerRltId}&isUnverifiedProvider=${isUnverifiedProvider}&providerId=${providerId}`;
    var count = parseInt($('#docCOunt').val());
    $('.doctor-removal-modal-error').addClass('hidden');
    if (!onRemoveDoctorAjaxFlag) return false;
    onRemoveDoctorAjaxFlag = false;
    jsonPost(submitLeadUrl)
      .then(data => {
        data = JSON.parse(data);
        if (data.status === 'pcffailure' || data.status === 'FAILURE') {
          onRemoveDoctorAjaxFlag = true;
          $('.doctor-removal-modal-error .generic-error-text').text(
            data.errorMessage
          );
          $('.doctor-removal-modal-error').removeClass('hidden');
        } else {
          $('.noRecordDiv_doctorFlow').hide();
          showNewDoctor();
          ACC.colorbox.close();
        }
      })
      .catch(error => {
        onRemoveDoctorAjaxFlag = true;
        $('.noRecordDiv_doctorFlow').show();
      });
    return false;
  }
  
  function showNewPhysician() {
    const viewPhysiciansUrl = `${API_REFERENCE.checkoutPhysician.viewPhysicians}`;
    if (!cancelPhysicianSearchAjaxFlag) return false;
    cancelPhysicianSearchAjaxFlag = false;
    htmlGet(viewPhysiciansUrl)
      .then(responseData => {
        createNewPhysicianSearchAjaxFlag = true;
        cancelPhysicianSearchAjaxFlag = true;
        const response = ACC.sanitizer.sanitizeHtmlDeeply(responseData);
        if (response) {
          $(noRecordDoctor).hide();
          $(doctorRowHead).html(
            $(response)
              .find(doctorRowHead)
              .html()
          );
          $(initialDoctorDiv).html($(response).find(initialDoctorDiv).html());
          $(initialDoctorDiv).find(bodySection).addClass('initial-Doctor-Block-Body');
          $('#createState,#searchPhysician_state').selectmenu();
          $('.formatDoctorPhone').val(function(index, text) {
            return formatPhoneNumber(text);
          });
        } else {
          $(noRecordDoctor)
            .show()
            .find('.noRecordError_span')
            .text(noRecordError);
        }
        ACC.colorbox.close();
      })
      .catch(error => {
        createNewPhysicianSearchAjaxFlag = true;
        cancelPhysicianSearchAjaxFlag = true;
      });
  }

  function submitCreateNewPhysicianForm(e) {
    var form = $(e.target).closest('form');
    let validateEditPhoneNumFlag = $(form).find('.editDoctorPhoneNumber').data("validateeditphonenumflag");
    let validateEditFaxNumFlag = $(form).find('.editDoctorFaxNumber').data("validateeditfaxnumflag");
    $('.global-error-message').addClass('hidden');
    $('.generic-error-container').addClass('hidden');
    if((validateEditPhoneNumFlag != undefined && !validateEditPhoneNumFlag) 
      || (validateEditFaxNumFlag!= undefined && !validateEditFaxNumFlag)) return
    if (
      $(form)
        .find('.multiAddressFlag')
        .val() == 'false'
    ) {
      let addProviderUrl =  `${ACC.config.encodedContextPath}${API_REFERENCE.accountSettings.addPhysician}`;
      let formData = form.serialize();
		if (location.href.indexOf('checkout') != -1) {
			addProviderUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutPhysician.saveSearchPhysician}`;
			formData = {};
			let selectedAddressradioButton = $(".select-multiple-address-popup #addres-list-table input[type='radio']:checked");
			formData.providerId = selectedAddressradioButton.attr('data-providerId');
			formData.locationId = selectedAddressradioButton.attr('data-locationId');
			formData.address = selectedAddressradioButton.attr('data-address');
			formData.city = selectedAddressradioButton.attr('data-city');
			formData.state = selectedAddressradioButton.attr('data-state');
			formData.zipCode = selectedAddressradioButton.attr('data-zipCode');
			formData.phoneNumber = selectedAddressradioButton.attr('data-phoneNumber');
			formData.npi = selectedAddressradioButton.attr('data-npi');
			$('#physicianForm').find(':input').each(function () {
			    if (this.name) {
			        formData[this.name] = this.value;
			    }
			});
		}
	 	
      if (!createNewPhysicianAjaxFlag) return false;
      createNewPhysicianAjaxFlag = false;
      formPostJsonResponse(addProviderUrl, formData)
        .then(data => {
			if (location.href.indexOf('checkout') != -1) {
				showNewPhysician();
			} else {
				if (data.errorMessage) {
					createNewPhysicianAjaxFlag = true;
					$('.generic-error-container .generic-error-text').text(
						data.errorMessage
					);
					$('.generic-error-container').removeClass('hidden');
					window.scrollTo(0, 0);
				} else {
					$('.noRecordDiv_doctorFlow').hide();
					ACC.colorbox.close();
					showNewDoctor();
				}
			}
        })
        .catch(error => {
          createNewPhysicianAjaxFlag = true;
          $('.noRecordDiv_doctorFlow').show();
          $('.add_new_doctor')
            .find('.global-error-message')
            .removeClass('hidden');
        });
    } else {
      multiAddressArray = [];

      $(this)
        .parents('.account-addnewdoc-search-results-table-body')
        .find('.add-user-address .col-xs-12')
        .find('input')
        .each(function(element, index) {
          multiAddressObj.providerId = $(this).attr('data-providerId');
          multiAddressObj.locationId = $(this).attr('data-locationId');
          multiAddressObj.address = $(this).attr('data-address');
          multiAddressObj.city = $(this).attr('data-city');
          multiAddressObj.state = $(this).attr('data-state');
          multiAddressObj.zipCode = $(this).attr('data-zipCode');
          multiAddressObj.phoneNumber = $(this).attr('data-phoneNumber');
          multiAddressObj.npi = $(this).attr('data-npi');
          multiAddressArray.push(multiAddressObj);
          multiAddressObj = {};
        });

      ACC.colorbox.open('', {
        html: $('#selectMultiAddress').html(),
        onLoad: $('#cboxOverlay').css('position', 'fixed'),
        width: checkWidth(),
        height: checkHeight(),
        className: 'account-idc-remove-doctor'
      });

      $('table .tbody-multiple-address').html('');

      multiAddressArray.forEach(element => console.log(element));

      $.each(multiAddressArray, function(j, item) {
        console.log(j);
        let radioBtn = $(
          '<tr><td class="selection-group"><input type="radio" name="selectMultiAddressRadio" id="' +
            '" data-providerId="' +
            item.providerId +
            '" data-locationId="' +
            item.locationId +
            '" data-address="' +
            item.address +
            '" data-city="' +
            item.city +
            '" data-state="' +
            item.state +
            '" data-zipCode="' +
            item.zipCode +
            '" data-phoneNumber="' +
            item.phoneNumber +
            '" data-npi="' +
            item.npi +
            '" class="form-check-input selectMultiAddressRadio"> </td>' +
            '<td>' +
            item.address +
            '</td>' +
            '<td>' +
            item.city +
            '</td>' +
            '<td>' +
            item.state +
            '</td>' +
            '<td>' +
            item.phoneNumber +
            '</td>' +
            '</tr>'
        );
        radioBtn.appendTo('table .tbody-multiple-address');
      });

      ACC.colorbox.resize();
    }

    return false;
  }

  function selectingMultipleAddressRow() {
    var form = $(this)
      .parents('.select-multiple-address-popup')
      .find('#addProviderFormM');

    form.find('#providerIdM').val($(this).data('providerid'));
    form.find('#locationIdM').val($(this).data('locationid'));
    form.find('#zipCodeM').val($(this).data('zipCode'));
    form.find('#stateM').val($(this).data('state'));
    form.find('#cityM').val($(this).data('city'));

    $('.addMultiProviderNextBtn').removeAttr('disabled');
  }

  function preventNextStepButton(){
    if(!nextStepForm){
      nextStepForm = true;
      $('#submitViewPhysician').submit();
    }
  }

  function saveDoctorAddInfo(e) {
    e.preventDefault();
    var form = $(e.target).closest('form');
    let validateEditPhoneNumFlag = $(form).find('.editDoctorPhoneNumber').data("validateeditphonenumflag");
    let validateEditFaxNumFlag = $(form).find('.editDoctorFaxNumber').data("validateeditfaxnumflag");
    if (validateEditPhoneNumFlag == true && validateEditFaxNumFlag == true )
    {
      $('.generic-error-container').addClass('hidden');
      const saveProviderUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.accountDoctor.saveProviderAdditionalInfo}`;
      const saveProviderData = form.serialize();
      if (!saveAddDoctorAjaxFlag) return false;
      saveAddDoctorAjaxFlag = false;
      formPostJsonResponse(saveProviderUrl, saveProviderData)
        .then(data => {
          if (data.status == 'SUCCESS') {
            $('.noRecordDiv_doctorFlow').hide();
            showNewDoctor();
          } else {
            saveAddDoctorAjaxFlag = true;
            $('.generic-error-container .generic-error-text').text(
              data.errorMessage
            );
            $('.generic-error-container').removeClass('hidden');
            window.scrollTo(0, 0);
          }
        })
        .catch(error => {
          saveAddDoctorAjaxFlag = true;
          $('.noRecordDiv_doctorFlow').show();
        });
      return false;
    }
  }

  function cancelUpdateFunction(e) {
    e.preventDefault();
    showNewDoctor();
    $(
      '.account-idc-review-details-add-form-row__fax .editDoctorInput'
    ).removeClass('error--bordering');
    $(
      '.account-idc-review-details-add-form-row__phn-nbr .editDoctorInput'
    ).removeClass('error--bordering');
    $('.account-idc-review-details-add-form-row__fax-nbr--error').addClass(
      'hidden'
    );
    $('.account-idc-review-details-add-form-row__phn-nbr--error').addClass(
      'hidden'
    );
    $(this)
      .closest('.account-doctor-section')
      .find('.account-idc-edit')
      .addClass('hidden');
    $(this)
      .closest('.account-doctor-section')
      .find('.account-doctor-first')
      .show();
    $(this)
      .closest('.account-doctor-section')
      .find('.account-doctor__divider')
      .show();
  }

  function is_int(value) {
    if (parseFloat(value) == parseInt(value) && !isNaN(value)) {
      return true;
    } else {
      return false;
    }
  }

  function getCityAndState() {
    var zipCode = $(this);

    if (zipCode.val().length >= 5 && isValidZipVal) {
      var addressRequest = {};
      addressRequest.address1 = $('#createAddressLine1').val();
      addressRequest.address2 = $('#createAddressLine2').val();
      addressRequest.zip = $('#createZipCode').val();
      var response = null;
      const getCityStateUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.accountDoctor.getCityStateNewPhysician}`;
      const addressData = JSON.stringify(addressRequest);
      jsonPost(getCityStateUrl, addressData).then(data => {
        response = data;

        if (response.city == '' || response.state == '') {
          $('.account-addnewdoc-state__error').removeClass('hidden');
        } else {
          $('.account-addnewdoc-state__error').addClass('hidden');
          $('#createCity').val(response.city);
          $('#createState').val(response.state);
          $('#createRdi').val(response.rdi);
        }
      });
    } else $('.account-addnewdoc-state__error').removeClass('hidden');
  }

  function validationOnPaste(e) {
    let isInvalidZipCode;
    isInvalidZipCode = zipCodeValidator(e, $(this));

    $(this)
      .removeClass('error-msg-textbox')
      .parent()
      .find('.invalid-zip-code-paste')
      .addClass('hidden');
    isValidZipVal = true;
    if (
      isInvalidZipCode &&
      $(this)
        .val()
        .trim() !== ''
    ) {
      $(this)
        .addClass('error-msg-textbox')
        .parent()
        .find('.invalid-zip-code-paste')
        .removeClass('hidden');
      isValidZipVal = false;
    }
  }

  function formatPhoneNumberField(phoneNumberString) {
    var phone = phoneNumberString.replace(/\D/g, '');
    var match = phone.match(/^(\d{1,3})(\d{0,3})(\d{0,4})$/);
    if (match) {
      phone = ''
        .concat(match[1])
        .concat(match[2] ? '.' : '')
        .concat(match[2])
        .concat(match[3] ? '.' : '')
        .concat(match[3]);
    }
    return phone;
  }
  function CopyPaste(e){
    var thisPhone = $(this);
    var pastedData = e.originalEvent.clipboardData.getData('text');
    pastedData= pastedData.replaceAll('.','');
    if(pastedData.length > 10){
      var first10Digits = pastedData.slice(0,10);
      setTimeout(function(){
        thisPhone.val(first10Digits);
        thisPhone.trigger('keyup');
      }, 10);
    }
  }

  var finalPhoneNumber = "";
  $(document).on(
    'keypress keyup',
    '#createPhoneNbr, #createFaxNbr, .editDoctorPhoneNumber, .editDoctorFaxNumber',
    function(e) {
      var thisPhone = $(this);
      var curval = $(this).val();
      if(curval.length === 12 && curval.split('.').length === 2){
        curval = finalPhoneNumber;
      }
      var cursorPosition = e.target.selectionStart;
      var phoneLength = curval.length;
      thisPhone.val(formatPhoneNumberField(curval));
      finalPhoneNumber = curval;
      if(e.target.selectionStart === e.target.selectionEnd){
       if(e.keyCode === 8 || e.keyCode === 127){
        thisPhone.focus();
        thisPhone[0].selectionStart = thisPhone[0].selectionEnd = cursorPosition;  
       } else if(phoneLength > cursorPosition){
        thisPhone.focus();
        thisPhone[0].selectionStart = thisPhone[0].selectionEnd = cursorPosition;
       }
      }
      thisPhone.trigger("input");
    }
  );

  $(document).on('paste','#createPhoneNbr, #createFaxNbr, .editDoctorPhoneNumber, .editDoctorFaxNumber',CopyPaste);
  $('body').on(
    'blur',
    '#createNewProviderForm #createZipCode',
    getCityAndState
  );
  $(document).on(
    'click',
    '.account-addnewdoc-search-results-table-body__select',
    selectingRow
  );
  $(document).on(
    'click',
    '.account-addnewdoc-search-results-table-header__dropdown',
    expandRow
  );
  $(document).on('click', '.account-doctor-add__button', addDoctorPage);
  $(document).on(
    'click',
    '.account-doctor-controls-remove,.account-idc-edit-controls-remove__btn',
    removeDoctor
  );
  $(document).on(
    'click',
    '.account-idc-remove-doctor-body-controls__save',
    removeDoctorfromDom
  );
  $(document).on('click', '.createDoctorSaveBtn', addDoctorPopUpSubmitBtn);
  $(document).on(
    'click',
    '.account-idc-remove-doctor-body-controls__cancel',
    function(e) {
      e.preventDefault();
      ACC.colorbox.close();
    }
  );
  $(document).on(
    'click',
    '.account-idc-review-header-primary__toggler,.toggle__overlay',
    togglingPrimaryCareDoctor
  );
  $(document).on(
    'click',
    '.account-addnewdoc-search-results-phys-not-list__btn',
    viewCreateNewPhysician
  );
  $(document).on('click', '.cancel_update', cancelUpdateFunction);
  $(document).on(
    'click',
    '.account-doctor-controls__add,.account-doctor-controls-edit',
    editPhysician
  );
  $(document).on(
    'keydown',
    "#provServPhone,#createFaxNbr,#createPhoneNbr,input[id^='reviewPhoneNbr'],input[id^='reviewFax'],input[id^='editPhoneNbr'],input[id^='editFaxNbr']",
    populateKey
  );
  $(document).on(
    'input',
    "#createExt,#provServPhone,#ext,input[id^='editPhoneNbr'],input[id^='editFaxNbr'],#createPhoneNbr,input[id ^='reviewPhoneNbr'],input[id^='reviewFax'],#createFaxNbr,input[id ^='editExt']",
    preventAlphabetsAndSpecialCharacters
  );
  /*$(document).on(
    'blur',
    "input[id ^='reviewPhoneNbr'],input[id^='reviewFax']",
    validateReviewPhnAndFaxNbr
  );*/
  $(document).on('blur', "input[id ^='reviewExt']", validateExt);
  $(document).on('submit', "form[id^='reviewForm']", submitEditForm);
  $(document).on(
    'click',
    '.account-idc-edit-controls-buttons__cancel,.account-idc-edit-controls-buttons__save',
    editWhichButtonClicked
  ); // Function bindings for Create New Physician form

  $(document).on('input', '#createLastName', validateCreateLastName);
  $(document).on('input', '#createFirstName', validateCreateFirstName);
  $(document).on('input', '#createPhoneNbr', validateCreatePhoneNbr);
  $(document).on('input', '.editDoctorPhoneNumber', validateEditFormPhoneNbr);
  $(document).on('input', '.editDoctorFaxNumber', validateEditFormFaxNbr);
  $(document).on('selectmenuchange', '#createState', validateCreateState);
  $(document).on('input', '#createFaxNbr', validateCreatFaxNbr);
  $(document).on(
    'click',
    '.account-create-newphysician-form__add',
    populateAddButtonClicked
  );
  $(document).on(
    'click',
    '.account-create-newphysician-form__cancel',
    populateCancelButtonClicked
  );
  $(document).on(
    'submit',
    '.account-create-newphysician-form',
    addDoctorSubmit
  ); // Function bindings for Add New Doctor Search form

  $(document).on('input', '#addLastName', validateAddDoctorReqdFields);
  $(document).on(
    'selectmenuchange',
    '#searchPhysician_state',
    validateAddDoctorReqdFields
  );
  $(document).on('blur', '#provServPhone', validateSearchPhoneNbr);
  $(document).on(
    'submit',
    '.account-addnewdoc-form',
    submitAddDoctorSearchForm
  );
  $(document).on(
    'click',
    '.account-idc-review-details-add-form-btn__detail,.addMultiProviderNextBtn',
    submitCreateNewPhysicianForm
  );
  $(document).on('click', '.saveDoctorAddInfo', saveDoctorAddInfo);
  $(document).on('click', '.pagination__next', navigateNext);
  $(document).on('click', '.pagination__previous', navigatePrevious);
  $(document).on('click', '.editDoctorToggle', editToggler);
  $(document).on('input change', '#createZipCode', validationOnPaste);
  $(document).on('input change', '#createZipCode', validateRequiredFields);
  $(document).on(
    'click',
    '.selectMultiAddressRadio',
    selectingMultipleAddressRow
  );
  $(document).on('click', '.checkout-physician-view-next-step', preventNextStepButton);
  //$(document).on('click', '.addMultiProviderNextBtn', submitMultiAddress);
});